import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  table: {
    background: theme.palette.background.paper,
  },
  tableHeadCell: {
    padding: '0 15px',
    height: 45,
    fontWeight: 'bold',
    fontSize: '14px',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.grey[200],
  },
  overWritePadding: {
    padding: '10px 15px',
    fontSize: '13px',
    color: theme.palette.text.secondary,
    maxWidth: '400px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  overWritePaddingRow: {
    fontSize: '0.8rem',
    padding: '0 15px',
  },
  switchDisabled: {
    opacity: 0.7,
    '& span': {
      cursor: 'default',
    },
  },
  headerInfoVal: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: theme.palette.primary.dark,
    marginRight: '6px',
  },
  headerInfoTitle: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#79797d',
  },
  headerInfoDivider: {
    width: '1px',
    height: '20px',
    backgroundColor: '#d5d2d5',
  },
  boldFont: {
    fontWeight: 'bold',
  },
  addMarginBottom: {
    marginBottom: '5px',
  },
}));

export default useStyles;